var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-card box"},[(_vm.img)?_c('img',{attrs:{"src":_vm.img}}):_vm._e(),_vm._t("img"),_c('div',{staticClass:"box-content"},[_vm._t("content")],2),_c('ul',{staticClass:"icon"},[_vm._t("icon")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }